import React from 'react';
import PropTypes from 'prop-types';

import {
  Button,
  Modal,
  getTranslation,
  TranslationProvider,
} from '@resy/ui-kitchen';

import Close from '../../svg/dynamic/close.svg';

const RatingFormModals = ({ rating, onCloseModal, showErrorModal }) => (
  <Modal
    isOpen={showErrorModal}
    styles={
      {
        content: {
          border: 'none',
          borderRadius: '5px',
          maxWidth: '340px',
          padding: '20px',
          inset: '25% 40px auto',
        },
      }
    }
  >
    <div className="RatingForm__modal">
      <div className="RatingForm__modal-head">
        <Button
          onClick={onCloseModal}
          variant="no-style"
          className="Button__close"
          aria-label={getTranslation({
            translationKey: 'close',
            fallback: 'Close',
          })}
          data-test-id="rating_form-button-close"
        >
          <Close />
        </Button>
      </div>
      <div className="RatingForm__modal-body">
        {
          !rating && (
            <>
              <TranslationProvider translationKey="rate_modal_rating_required_title">
                <h1>Rating Required</h1>
              </TranslationProvider>
              <TranslationProvider translationKey="rate_modal_rating_required_body">
                <p>To submit a review, please select a star rating.</p>
              </TranslationProvider>
            </>
          )
        }
        {
          rating && (
            <>
              <TranslationProvider translationKey="rate_modal_comments_required_title">
                <h1>Comment Required</h1>
              </TranslationProvider>
              <TranslationProvider translationKey="rate_modal_comments_required_title">
                <p>Please let us know what went wrong with your reservation so we can work with the restaurant to make it better.</p>
              </TranslationProvider>
            </>
          )
        }
        <TranslationProvider translationKey="ok">
          <Button
            variant="secondary"
            onClick={onCloseModal}
            data-test-id="rating_form-button-ok"
          >
            Ok
          </Button>
        </TranslationProvider>
      </div>
    </div>
  </Modal>
);

RatingFormModals.propTypes = {
  rating: PropTypes.number,
  onCloseModal: PropTypes.func,
  showErrorModal: PropTypes.bool,
};

RatingFormModals.defaultProps = {
  rating: null,
  onCloseModal: () => {},
  showErrorModal: false,
};

RatingFormModals.displayName = 'RatingFormModals';
export default RatingFormModals;
